import { Line2Struct, Vec2Struct } from './types';

/**
 * A no-allocation version of `Line2D#getPointAlongLine`.
 *
 * Only intended for use in performance-critical code where you need to avoid heap allocations.
 */
export function getPointAlongLine(line: Line2Struct, distance: number, result: Vec2Struct) {
  result.x = line.basePoint.x + distance * line.direction.x;
  result.y = line.basePoint.y + distance * line.direction.y;
}
